import {
  CheckCircleRounded,
  GroupAddRounded,
  VpnKeyRounded,
} from '@material-ui/icons';
import { Step } from '../../common/Steper';
export const initialError = { user: '', keys: '' };
export const initialValidations = {
  user: false,
  keys: false,
  complete: false,
};
export const initialValuesLoan = {
  users_id: '',
  keys: [1],
};
export const initialSteps: Step[] = [
  {
    icon: <CheckCircleRounded />,
    label: 'Prestamos',
  },
  {
    icon: <GroupAddRounded />,
    label: 'Receptor',
  },
  {
    icon: <VpnKeyRounded />,
    label: 'Llaves',
  },
  {
    icon: <CheckCircleRounded />,
    label: 'Confirmar',
  },
];

export enum StepsP2P {
  VerifyLoans = 0,
  SelectUser = 1,
  SelectKeys = 2,
  ConfirmSend = 3,
}
